import { type FormEvent, useState } from 'react';
import { useUpdateOrgMemberRole } from '../../hooks/useAdminData';
import { Modal } from '../Modal';

interface ChangeRoleModalProps {
  open: boolean;
  onClose: () => void;
  orgId: string;
  userId: string;
  currentRole: string;
  userName: string;
}

export function ChangeRoleModal({
  open,
  onClose,
  orgId,
  userId,
  currentRole,
  userName,
}: ChangeRoleModalProps) {
  const [role, setRole] = useState(currentRole);
  const updateRole = useUpdateOrgMemberRole();

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    updateRole.mutate({ orgId, userId, role }, { onSuccess: onClose });
  }

  return (
    <Modal open={open} onClose={onClose} title="Change Role" size="sm">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <p className="text-sm text-text-secondary mb-3">
            Change role for <span className="text-text font-medium">{userName}</span>
          </p>
          <label className="block text-sm font-medium text-text-secondary mb-1">Current Role</label>
          <div className="px-3 py-2 bg-background border border-border rounded-lg text-sm text-text-muted">
            {currentRole}
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-1">New Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="w-full px-3 py-2 bg-surface border border-border rounded-lg text-sm text-text focus:outline-none focus:border-primary transition-colors"
          >
            <option value="member">Member</option>
            <option value="admin">Admin</option>
            <option value="owner">Owner</option>
          </select>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg border border-border text-text-secondary hover:bg-surface-hover transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={role === currentRole || updateRole.isPending}
            className="px-4 py-2 text-sm rounded-lg font-medium bg-primary text-background hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {updateRole.isPending ? 'Updating...' : 'Update Role'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
